"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDismissInterstitialBase = void 0;
const useDismissInterstitialService_hook_1 = require("./useDismissInterstitialService.hook");
const useDismissInterstitialBase = (repository) => {
    const { dismissInterstitialCall, isDismissInterstitialLoading, isDismissInterstitialSuccess, isDismissInterstitialError } = (0, useDismissInterstitialService_hook_1.useDismissInterstitialService)(repository);
    return {
        dismissInterstitialCall,
        isDismissInterstitialLoading,
        isDismissInterstitialSuccess,
        isDismissInterstitialError,
    };
};
exports.useDismissInterstitialBase = useDismissInterstitialBase;
//# sourceMappingURL=useDismissInterstitialBase.hook.js.map